<template>
  <div
    id="carousel"
    style="background-color:white;"
    v-show="!loaded"
    :style="{ 'pointer-events': !gesture ? 'auto' : 'none' }"
  >
    <img width="100%" :src="isamnet" @load="onLoad" />
    <div>
      <div style="position: absolute;border: 0px;width: 65%;">
        <div id="ucf-slide">
          <div class="carousel-wrapper">
            <ul class="carousel-container">
              <li
                :class="index < 3 ? 'box' : 'box box-hide'"
                v-for="(carousel, index) in creative.carousels"
                :key="index"
              >
                <a :href="carousel.landing_page" target="_blank">
                  <img :src="carousel.image_url" @load="onLoad" />
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <img
        src="https://cdn.aralego.net/rich_media/assets/carousel/bg2.png"
        width="100%"
        @load="onLoad"
      />
    </div>
    <img
      src="https://cdn.aralego.net/rich_media/assets/carousel/bg3.png"
      width="100%"
      @load="onLoad"
    />
  </div>
</template>

<script>
import mixPreview from "@/components/mixins/preview.js";
import mixMobile from "@/components/mixins/mobile.js";
export default {
  data() {
    return {
      loaded: this.creative.carousels.length + 3,
    };
  },
  computed: {
    isamnet() {
      let domain = window.location.hostname;
      let isAmnet = 'https://cdn.aralego.net/rich_media/assets';
      if (domain === "prism.amnet.tw") {
        isAmnet += '/amnet/carousel-bg.png';
      } else {
        isAmnet += '/carousel/bg1.png';
      }
      return isAmnet;
    },
  },
  async mounted() {
    this.viewport();
    await this.$nextTick();
    this.intervalEvent = setInterval(this.shift, 3000);
    this.left = () => this.handleGesture("left");
    this.right = () => this.handleGesture("right");
    const container = document.querySelector(".carousel-container");
    this.handleTouch(container);
    this.handleAnimate(container);
  },
  mixins: [mixPreview, mixMobile],
  methods: {
    handleGesture(gesture) {
      if (this.isAnimating) return;
      gesture === "left" ? this.shift() : this.invert_shift();
      clearInterval(this.intervalEvent);
      this.intervalEvent = setInterval(this.shift, 3000);
    },
    shift() {
      const container = document.querySelector(".carousel-container");
      container.append(container.firstChild);
      var boxes = document.querySelectorAll(".box");
      for (var i = 0; i < boxes.length; i++) {
        if (i < 3) {
          boxes[i].className = `box move-to-position${i + 1}-from-left`;
        } else {
          boxes[i].className = "box move-out-from-left box-hide";
        }
      }
    },
    invert_shift() {
      const container = document.querySelector(".carousel-container");
      container.insertBefore(container.lastChild, container.firstChild);
      var boxes = document.querySelectorAll(".box");
      for (var i = 0; i < boxes.length; i++) {
        if (i < 3) {
          boxes[i].className = `box move-to-position${i + 1}-from-right`;
        } else {
          boxes[i].className = "box move-out-from-right box-hide";
        }
      }
    },
  },
};
</script>

<style lang="sass" scoped>
#ucf-slide
  .carousel-wrapper
    margin: 0 auto
    width: 600px
    height: 300px
    display: flex
    flex-direction: column
    align-items: center
    -webkit-perspective: 1500px
    -moz-perspective: 1500px
    -ms-perspective: 1500px
    perspective: 1500px
    .carousel-container
      margin: 0
      display: flex
      align-items: center
      justify-content: center
      height: 300px
      -webkit-transform-style: preserve-3d
      -moz-transform-style: preserve-3d
      -ms-transform-style: preserve-3d
      transform-style: preserve-3d
      .box
        width: 350px
        height: 250px
        display: flex
        justify-content: center
        align-items: center
        position: relative
        &:nth-child(1)
          transform: scale(0.75) translateZ(0)
          left: 20%
        &:nth-child(2)
          transform: scale(1) translateZ(50px)
          left: 0%
        &:nth-child(3)
          transform: scale(0.75) translateZ(0)
          left: -20%
        &>a
          height: 250px
          display: block
          &>img
            height: 100%
            display: block
            margin: 0 auto
      .box-hide
        display: none
      .move-out-from-left
        animation: moveOutLeft 0.5s ease-in-out
      .move-to-position1-from-left
        animation: moveToP1Left 0.5s ease-in-out
      .move-to-position2-from-left
        animation: moveToP2Left 0.5s ease-in-out
      .move-to-position3-from-left
        animation: moveToP3Left 0.5s ease-in-out
      .move-out-from-right
        animation: moveOutRight 0.5s ease-in-out
      .move-to-position1-from-right
        animation: moveToP1Right 0.5s ease-in-out
      .move-to-position2-from-right
        animation: moveToP2Right 0.5s ease-in-out
      .move-to-position3-from-right
        animation: moveToP3Right 0.5s ease-in-out

@include keyframes(moveOutLeft)
  0%
    opacity: 1
  100%
    opacity: 0
@include keyframes(moveToP1Left)
  0%
    transform: scale(1) translateX(40%) translateZ(50px)
  100%
    transform: scale(0.75) translateX(0) translateZ(0px)
@include keyframes(moveToP2Left)
  0%
    transform: scale(0.75) translateX(53.5%) translateZ(0px)
  100%
    transform: scale(1) translateX(0) translateZ(50px)
@include keyframes(moveToP3Left)
  0%
    transform: scale(0.5) translateX(-40%) translateZ(-50px)
    opacity: 0.5
  100%
    transform: scale(0.75) translateX(0) translateZ(0px)
    opacity: 1

@include keyframes(moveOutRight)
  0%
    opacity: 0
  100%
    opacity: 1
@include keyframes(moveToP1Right)
  0%
    transform: scale(0.5) translateX(-40%) translateZ(-0px)
    opacity: 0.5
  100%
    transform: scale(0.75) translateX(0%) translateZ(0px)
    opacity: 1
@include keyframes(moveToP2Right)
  0%
    transform: scale(0.75) translateX(-53.5%) translateZ(0px)
  100%
    transform: scale(1) translateX(0%) translateZ(50px)
@include keyframes(moveToP3Right)
  0%
    transform: scale(1) translateX(-40%) translateZ(50px)
  100%
    transform: scale(0.75) translateX(0) translateZ(0px)
</style>
